import moment from 'moment';
import { EMPTY_VALUE } from '../constants';

type FormatDateTimeOptions = {
  format?: string;
  fallback?: string;
};

const DEFAULT_DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';

const formatDateTime = (
  value?: Date | string | number | null,
  options?: FormatDateTimeOptions
) => {
  const format = options?.format ?? DEFAULT_DATE_TIME_FORMAT;
  const fallback = options?.fallback ?? EMPTY_VALUE;

  if (value === undefined || value === null || value === '') {
    return fallback;
  }

  const parsed = moment(value);
  if (!parsed.isValid()) {
    return fallback;
  }

  return parsed.format(format);
};

export default formatDateTime;
